<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content >
  <div class="theme-container w-100 flex-col">
    <div class="flex-col w-100">
      <div class="pb-3 w-100" color="primary">{{message}}</div>
      @for (step of missingRequiredParameters; track $index; let i = $index) {
        <div>
          <ol class="ml-4 mt-1 mb-1 w-100">
            <ul class="text-bold">Step {{step.sequenceNo+1}}: {{getMoovStepType(step)}}</ul>
          </ol>
        </div>
      }
    </div>
  </div>
  <div class="pt-3">On the moov steps card on the left, click the cog icon to enter required parameters on the steps mentioned above.</div>
</mat-dialog-content>

<mat-dialog-actions >
  <div class="w-100 p-2 flex-row justify-end items-center mt-1">
    <a mat-button class="dialog-btn" color="primary" (click)="onConfirmClick()"><span class="text-bold">{{confirmButtonText}}</span></a>
  </div>
</mat-dialog-actions>